module.exports = __webpack_public_path__ + "54ab338b98ba682bd877d4409ee0dc05.svg";